export const transformChurnDataToSeries = (reportData) => {
    const categories = reportData.map(item => {
        const date = new Date(item.date);
        return date.toLocaleDateString("en-US", { 
            month: "short", 
            day  : "numeric" 
        });
    });
 
    const series = [
        {
            name : "Expansion",
            data : reportData.map(item => item.expansion),
            color: "#93c5fd" 
        },
        {
            name : "Churn",
            data : reportData.map(item => item.churned),
            color: "#fda4af" 
        },
        {
            name : "Contraction",
            data : reportData.map(item => item.contraction),
            color: "#fde68a" 
        }
    ];

    return {
        categories,
        series
    };
};
